/*eslint-disable no-useless-escape*/
const EMAIL_REGEX = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;

const regex = {
  EMAIL_REGEX,
};

export default regex;
